export const DOCUMENTATION_LINK_URL = 'https://per.co.na/PMM3_RelNotes';
export const MIGRATION_LINK_URL = 'https://per.co.na/migrate_to_PMM3';
